import { User, Bot, Volume2 } from 'lucide-react';
import { useRef, useEffect } from 'react';

const ChatMessages = ({ messages, scenario, ttsEnabled = false, hideCitizenText = false }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  if (messages.length === 0) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center p-6 rounded-xl border-2 max-w-md" style={{ backgroundColor: '#CAE9FA', borderColor: '#2E6CF5' }}>
          <div className="text-4xl mb-3">📞</div>
          <h3 className="text-lg font-bold mb-2" style={{ color: '#002768' }}>Appel Entrant</h3>
          <p className="text-sm mb-4" style={{ color: '#002768' }}>
            Un citoyen est en ligne. Répondez comme un répartiteur 911.
          </p>
          <div className="bg-white p-3 rounded-lg border" style={{ borderColor: '#2E6CF5' }}>
            <p className="text-xs text-gray-500 mb-1">Exemple d'ouverture:</p>
            <p className="text-sm font-semibold" style={{ color: '#002768' }}>
              "911 {scenario?.category}, quelle est votre adresse?"
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {messages.map((msg, index) => (
        <div
          key={index}
          className={`flex ${msg.speaker === 'operator' ? 'justify-end' : 'justify-start'}`}
        >
          <div
            className={`flex items-start space-x-2 max-w-[80%] ${
              msg.speaker === 'operator' ? 'flex-row-reverse space-x-reverse' : ''
            }`}
          >
            <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-white"
                 style={{ backgroundColor: msg.speaker === 'operator' ? '#002768' : '#EE2130' }}>
              {msg.speaker === 'operator' ? <User className="w-4 h-4" /> : <Bot className="w-4 h-4" />}
            </div>
            <div
              className={`px-4 py-2 rounded-2xl ${
                msg.speaker === 'operator'
                  ? 'text-white rounded-br-md'
                  : 'bg-gray-100 text-gray-800 rounded-bl-md'
              }`}
              style={msg.speaker === 'operator' ? { backgroundColor: '#002768' } : {}}
              translate="no"
            >
              {msg.speaker === 'citizen' && hideCitizenText && ttsEnabled ? (
                <p className="text-sm italic flex items-center gap-2 text-gray-500">
                  <Volume2 className="w-4 h-4 flex-shrink-0" />
                  <span>Audio seulement</span>
                </p>
              ) : (
                <p className="text-sm" translate="no">{msg.text}</p>
              )}
            </div>
          </div>
        </div>
      ))}
      <div ref={messagesEndRef} />
    </>
  );
};

export default ChatMessages;
